import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ListingDetailPage } from './pages/ListingDetailPage';
import { CreateListingPage } from './pages/CreateListingPage';
import { BuyerDashboardPage } from './pages/BuyerDashboardPage';
import { SellerDashboardPage } from './pages/SellerDashboardPage';
import { DeveloperDashboardPage } from './pages/DeveloperDashboardPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { NriBuyerDashboardPage } from './pages/NriBuyerDashboardPage';
import { AuthorityDashboardPage } from './pages/AuthorityDashboardPage';
import { LegalGuidesPage } from './pages/LegalGuidesPage';
import { ScrollToTop } from './components/ScrollToTop';
import { HelpPage } from './pages/HelpPage';
import { SettingsPage } from './pages/SettingsPage';
import { AuctionsPage } from './pages/AuctionsPage';
// Auth Pages
import { SignupPage } from './pages/auth/SignupPage';
import { SignInPage } from './pages/auth/SignInPage';
import { VerifyOTPPage } from './pages/auth/VerifyOTPPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { Verify2FAPage } from './pages/auth/Verify2FAPage';
// Legal Pages
import { TermsOfUsePage } from './pages/legal/TermsOfUsePage';
import { PrivacyPolicyPage } from './pages/legal/PrivacyPolicyPage';
import { AccessibilityPolicyPage } from './pages/legal/AccessibilityPolicyPage';
// Footer Pages
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { CareersPage } from './pages/CareersPage';
import { FAQPage } from './pages/FAQPage';
import { SupportPage } from './pages/SupportPage';
import { BlogPage } from './pages/BlogPage';
import { PressPage } from './pages/PressPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
// Buyer Pages
import { ShortlistedPlotsPage } from './pages/buyer/ShortlistedPlotsPage';
import { MyInquiriesPage } from './pages/buyer/MyInquiriesPage';
import { InquiryDetailPage } from './pages/buyer/InquiryDetailPage';
import { SettingsPage as BuyerSettingsPage } from './pages/buyer/SettingsPage';
// NRI Pages
import { PoaLegalPage } from './pages/nri/PoaLegalPage';
import { VirtualToursPage } from './pages/nri/VirtualToursPage';
import { TaxForexPage } from './pages/nri/TaxForexPage';
// Seller Pages
import { InquiriesPage } from './pages/seller/InquiriesPage';
import { PerformancePage } from './pages/seller/PerformancePage';
import { SettingsPage as SellerSettingsPage } from './pages/seller/SettingsPage';
// Developer Pages
import { InventoryPage } from './pages/developer/InventoryPage';
import { LeadsCrmPage } from './pages/developer/LeadsCrmPage';
import { LeadDetailPage } from './pages/developer/LeadDetailPage';
import { ReportsPage } from './pages/developer/ReportsPage';
// Admin Pages
import { UserManagementPage } from './pages/admin/UserManagementPage';
import { DisputesPage } from './pages/admin/DisputesPage';
import { RiskAnalysisPage } from './pages/admin/RiskAnalysisPage';
import { DisputeDetailPage } from './pages/admin/DisputeDetailPage';
import { UserDetailPage } from './pages/admin/UserDetailPage';
import { AdvocacyModerationPage } from './pages/admin/AdvocacyModerationPage';
// Authority Pages
import { AuctionManagementPage } from './pages/authority/AuctionManagementPage';
import { ComplianceTrackingPage } from './pages/authority/ComplianceTrackingPage';
import { ReportsPage as AuthorityReportsPage } from './pages/authority/ReportsPage';
import { PublicListingsPage } from './pages/authority/PublicListingsPage';
import { AuctionDetailPage } from './pages/authority/AuctionDetailPage';
import { ComplianceDetailPage } from './pages/authority/ComplianceDetailPage';
import { CreateAuctionPage } from './pages/authority/CreateAuctionPage';
import { CreatePublicListingPage } from './pages/authority/CreatePublicListingPage';
import { PublicListingDetailPage } from './pages/authority/PublicListingDetailPage';
// Transaction Pages
import { MakeOfferPage } from './pages/transaction/MakeOfferPage';
import { TransactionDetailPage } from './pages/transaction/TransactionDetailPage';
// Profile Pages
import { SellerProfilePage } from './pages/profile/SellerProfilePage';
import { PersonalProfilePage } from './pages/profile/PersonalProfilePage';
import { EditProfilePage } from './pages/profile/EditProfilePage';
// Advocacy Pages
import { AdvocacyPage } from './pages/AdvocacyPage';
import { TrendingIssuesPage } from './pages/advocacy/TrendingIssuesPage';
import { SubmitAdvocacyPage } from './pages/advocacy/SubmitAdvocacyPage';
import { MyAdvocacyPostsPage } from './pages/advocacy/MyAdvocacyPostsPage';
import { AdvocacyTrendingDetailPage } from './pages/advocacy/AdvocacyTrendingDetailPage';
import { AdvocacyPostDetailPage } from './pages/advocacy/AdvocacyPostDetailPage';
function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        {/* Public Routes */}
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/listing/:id" element={<ListingDetailPage data-id="element-6" />} data-id="element-5" />
        <Route path="/legal-guides" element={<LegalGuidesPage data-id="element-8" />} data-id="element-7" />
        <Route path="/help" element={<HelpPage data-id="element-10" />} data-id="element-9" />
        <Route path="/settings" element={<SettingsPage data-id="element-12" />} data-id="element-11" />
        <Route path="/auctions" element={<AuctionsPage data-id="element-14" />} data-id="element-13" />

        {/* Advocacy Routes - Public */}
        <Route path="/advocacy" element={<AdvocacyPage data-id="element-16" />} data-id="element-15" />
        <Route path="/advocacy/trending" element={<TrendingIssuesPage data-id="element-18" />} data-id="element-17" />
        <Route path="/advocacy/trending/:id" element={<AdvocacyTrendingDetailPage data-id="element-20" />} data-id="element-19" />
        <Route path="/advocacy/post/:id" element={<AdvocacyPostDetailPage data-id="element-22" />} data-id="element-21" />
        <Route path="/advocacy/submit" element={<SubmitAdvocacyPage data-id="element-24" />} data-id="element-23" />
        <Route path="/advocacy/my-posts" element={<MyAdvocacyPostsPage data-id="element-26" />} data-id="element-25" />

        {/* Footer Pages */}
        <Route path="/about" element={<AboutPage data-id="element-28" />} data-id="element-27" />
        <Route path="/contact" element={<ContactPage data-id="element-30" />} data-id="element-29" />
        <Route path="/careers" element={<CareersPage data-id="element-32" />} data-id="element-31" />
        <Route path="/faq" element={<FAQPage data-id="element-34" />} data-id="element-33" />
        <Route path="/support" element={<SupportPage data-id="element-36" />} data-id="element-35" />
        <Route path="/blog" element={<BlogPage data-id="element-38" />} data-id="element-37" />
        <Route path="/press" element={<PressPage data-id="element-40" />} data-id="element-39" />
        <Route path="/cookies" element={<CookiePolicyPage data-id="element-42" />} data-id="element-41" />

        {/* Auth Routes */}
        <Route path="/auth/signup" element={<SignupPage data-id="element-44" />} data-id="element-43" />
        <Route path="/auth/signin" element={<SignInPage data-id="element-46" />} data-id="element-45" />
        <Route path="/auth/verify-otp" element={<VerifyOTPPage data-id="element-48" />} data-id="element-47" />
        <Route path="/auth/forgot-password" element={<ForgotPasswordPage data-id="element-50" />} data-id="element-49" />
        <Route path="/auth/verify-2fa" element={<Verify2FAPage data-id="element-52" />} data-id="element-51" />

        {/* Legal Routes */}
        <Route path="/terms" element={<TermsOfUsePage data-id="element-54" />} data-id="element-53" />
        <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-56" />} data-id="element-55" />
        <Route path="/accessibility" element={<AccessibilityPolicyPage data-id="element-58" />} data-id="element-57" />

        {/* Create Listing */}
        <Route path="/create-listing" element={<CreateListingPage data-id="element-60" />} data-id="element-59" />

        {/* Dashboard Routes */}
        <Route path="/dashboard" element={<BuyerDashboardPage data-id="element-62" />} data-id="element-61" />
        <Route path="/dashboard/seller" element={<SellerDashboardPage data-id="element-64" />} data-id="element-63" />
        <Route path="/dashboard/developer" element={<DeveloperDashboardPage data-id="element-66" />} data-id="element-65" />
        <Route path="/dashboard/admin" element={<AdminDashboardPage data-id="element-68" />} data-id="element-67" />
        <Route path="/dashboard/nri-buyer" element={<NriBuyerDashboardPage data-id="element-70" />} data-id="element-69" />
        <Route path="/dashboard/authority" element={<AuthorityDashboardPage data-id="element-72" />} data-id="element-71" />

        {/* Buyer Routes */}
        <Route path="/buyer/shortlisted" element={<ShortlistedPlotsPage data-id="element-74" />} data-id="element-73" />
        <Route path="/buyer/inquiries" element={<MyInquiriesPage data-id="element-76" />} data-id="element-75" />
        <Route path="/buyer/inquiries/:id" element={<InquiryDetailPage data-id="element-78" />} data-id="element-77" />
        <Route path="/buyer/settings" element={<BuyerSettingsPage data-id="element-80" />} data-id="element-79" />

        {/* NRI Routes */}
        <Route path="/nri/poa-legal" element={<PoaLegalPage data-id="element-82" />} data-id="element-81" />
        <Route path="/nri/virtual-tours" element={<VirtualToursPage data-id="element-84" />} data-id="element-83" />
        <Route path="/nri/tax-forex" element={<TaxForexPage data-id="element-86" />} data-id="element-85" />

        {/* Seller Routes */}
        <Route path="/seller/inquiries" element={<InquiriesPage data-id="element-88" />} data-id="element-87" />
        <Route path="/seller/performance" element={<PerformancePage data-id="element-90" />} data-id="element-89" />
        <Route path="/seller/settings" element={<SellerSettingsPage data-id="element-92" />} data-id="element-91" />

        {/* Developer Routes */}
        <Route path="/developer/inventory" element={<InventoryPage data-id="element-94" />} data-id="element-93" />
        <Route path="/developer/leads" element={<LeadsCrmPage data-id="element-96" />} data-id="element-95" />
        <Route path="/developer/leads/:id" element={<LeadDetailPage data-id="element-98" />} data-id="element-97" />
        <Route path="/developer/reports" element={<ReportsPage data-id="element-100" />} data-id="element-99" />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminDashboardPage data-id="element-102" />} data-id="element-101" />
        <Route path="/admin/users" element={<UserManagementPage data-id="element-104" />} data-id="element-103" />
        <Route path="/admin/users/:id" element={<UserDetailPage data-id="element-106" />} data-id="element-105" />
        <Route path="/admin/disputes" element={<DisputesPage data-id="element-108" />} data-id="element-107" />
        <Route path="/admin/disputes/:id" element={<DisputeDetailPage data-id="element-110" />} data-id="element-109" />
        <Route path="/admin/risk" element={<RiskAnalysisPage data-id="element-112" />} data-id="element-111" />
        <Route path="/admin/advocacy-moderation" element={<AdvocacyModerationPage data-id="element-114" />} data-id="element-113" />

        {/* Authority Routes */}
        <Route path="/authority" element={<AuthorityDashboardPage data-id="element-116" />} data-id="element-115" />
        <Route path="/authority/auctions" element={<AuctionManagementPage data-id="element-118" />} data-id="element-117" />
        <Route path="/authority/auctions/:id" element={<AuctionDetailPage data-id="element-120" />} data-id="element-119" />
        <Route path="/authority/auctions/create" element={<CreateAuctionPage data-id="element-122" />} data-id="element-121" />
        <Route path="/authority/compliance" element={<ComplianceTrackingPage data-id="element-124" />} data-id="element-123" />
        <Route path="/authority/compliance/:id" element={<ComplianceDetailPage data-id="element-126" />} data-id="element-125" />
        <Route path="/authority/reports" element={<AuthorityReportsPage data-id="element-128" />} data-id="element-127" />
        <Route path="/authority/listings" element={<PublicListingsPage data-id="element-130" />} data-id="element-129" />
        <Route path="/authority/listings/create" element={<CreatePublicListingPage data-id="element-132" />} data-id="element-131" />
        <Route path="/authority/listings/:id" element={<PublicListingDetailPage data-id="element-134" />} data-id="element-133" />

        {/* Transaction Routes */}
        <Route path="/transaction/offer/:listingId" element={<MakeOfferPage data-id="element-136" />} data-id="element-135" />
        <Route path="/transaction/:id" element={<TransactionDetailPage data-id="element-138" />} data-id="element-137" />

        {/* Profile Routes */}
        <Route path="/profile" element={<PersonalProfilePage data-id="element-140" />} data-id="element-139" />
        <Route path="/profile/edit" element={<EditProfilePage data-id="element-142" />} data-id="element-141" />
        <Route path="/seller/profile/:id" element={<SellerProfilePage data-id="element-144" />} data-id="element-143" />
      </Routes>
    </Router>;
}
export { App };